import React, { useState } from "react";
import { PageShell, SoftCard } from "./ui";
import { useAstriaCopy, CopyKey } from "./copy";

type Kind = "reflection" | "decision" | "completed_step" | "checkin";
const LABEL: Record<Kind, CopyKey> = {
  reflection: "kindReflection",
  decision: "kindDecision",
  completed_step: "kindStep",
  checkin: "kindCheckin",
};
const ENTRIES: { kind: Kind; text: CopyKey; when: CopyKey }[] = [
  { kind: "checkin", text: "jEntry1", when: "jWhen1" },
  { kind: "completed_step", text: "jEntry2", when: "jWhen2" },
  { kind: "decision", text: "jEntry3", when: "jWhen3" },
  { kind: "reflection", text: "jEntry4", when: "jWhen4" },
];

const JourneyStoryPage: React.FC = () => {
  const c = useAstriaCopy();
  const [filter, setFilter] = useState<Kind | "all">("all");
  const shown = ENTRIES.filter((e) => filter === "all" || e.kind === filter);

  return (
    <PageShell title={c("navJourney")} sentence={c("journeySub")}>
      <div className="flex flex-wrap justify-center gap-2">
        {(["all", ...Object.keys(LABEL)] as (Kind | "all")[]).map((k) => (
          <button
            key={k}
            type="button"
            onClick={() => setFilter(k)}
            className="px-4 py-1.5 text-sm"
            style={{
              borderRadius: "var(--astria-radius-pill)",
              background: filter === k ? "var(--astria-accent-glow)" : "var(--astria-surface-soft)",
              color: filter === k ? "var(--astria-text-primary)" : "var(--astria-text-secondary)",
            }}
          >
            {k === "all" ? c("all") : c(LABEL[k])}
          </button>
        ))}
      </div>

      <div className="relative pl-6">
        <div
          className="absolute bottom-2 left-[7px] top-2 w-px"
          style={{ background: "linear-gradient(var(--astria-accent-primary), transparent)" }}
        />
        <div className="space-y-4">
          {shown.map((e, idx) => (
            <div key={e.text} className="relative astria-slide-up" style={{ animationDelay: `${idx * 60}ms` }}>
              <span
                className="absolute -left-[22px] top-5 h-3 w-3 rounded-full"
                style={{ background: "var(--astria-accent-primary)", boxShadow: "0 0 12px var(--astria-accent-glow)" }}
              />
              <SoftCard>
                <div className="flex justify-between text-xs uppercase tracking-widest text-astria-muted">
                  <span>{c(LABEL[e.kind])}</span>
                  <span>{c(e.when)}</span>
                </div>
                <p className="mt-2 text-astria-text">{c(e.text)}</p>
              </SoftCard>
            </div>
          ))}
        </div>
      </div>

      <p className="text-center text-xs text-astria-muted">
        {c("journeyNote")}
      </p>
    </PageShell>
  );
};

export default JourneyStoryPage;
